import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryWithRouteParam, ThunkApi} from '../interfaces'

import navigateToRoute from './navigateToRoute'

type NavigateToSaleHistoryParam = LocationChangeHistoryWithRouteParam

/** 정산내역 */
const navigateToSaleSettlement = createAsyncThunk<void, NavigateToSaleHistoryParam, ThunkApi<unknown>>(
    'navigateTo/sale/settlement',
    ({historyType = 'PUSH', routeBased = false}, {dispatch}) => {
        if (routeBased) {
            dispatch(navigateToRoute({historyType, path: ROUTER_ORDER_SALE_SETTLEMENT.MAIN.getPath()}))
        } else {
            changeBrowserLocation({
                type: historyType,
                url: ROUTER_ORDER_SALE_SETTLEMENT.MAIN.getHref(),
            })
        }
    },
)

export default navigateToSaleSettlement
